<template>
  <card class="card-stats" :show-footer-line="true">
    <div class="page-main-card-body-container">
      <div class="row">
        <div style="padding-left: 0" class="col-7 price text-right">
          <img class="money-table-logo" :src="icon" />
          {{ title }}
        </div>
        <div style="padding-right: 0" class="col-5 action-link-container">
          <b-link class="action-link link-blue" :to="buyLink">خرید</b-link>
          <span class="horizontal-text-seperator"> | </span>
          <b-link class="action-link link-red" :to="sellLink">فروش</b-link>
        </div>
      </div>
    </div>
  </card>
</template>
<script>
import Card from "./Card.vue";

export default {
  name: "stats-card",
  components: {
    Card,
  },
  props: {
    type: {
      type: String,
      default: "primary",
    },
    icon: String,
    title: String,
    buyLink: String,
    sellLink: String,
    subTitle: String,
    iconClasses: [String, Array],
  },
};
</script>
<style lang="scss">
.action-link-container {
  text-align: left;
  max-width: 40%;
}
</style>
